import { useEffect, useState } from 'react';
import { Box, Group, Paper, Text, ThemeIcon } from '@mantine/core';
import { IconClock } from '@tabler/icons-react';
import { formatTimeOnly, nowISO, parseDateTime } from 'utils/dateUtils';
import { useCurrentSiteStore } from 'store';
import { useProviderAllSites } from 'hooks/useProviderAllSites';

export const DigitalClock = () => {
  const { timezone } = useCurrentSiteStore();

  const [time, setTime] = useState('');

  const { isAllSites } = useProviderAllSites();

  useEffect(() => {
    const updateClock = () => {
      setTime(
        formatTimeOnly(parseDateTime(nowISO(timezone)), {
          timezone,
        })
      );
    };
    updateClock();
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, [timezone]);

  const locationLabel =
    timezone
      .split('/')
      .pop()
      ?.replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase()) ?? timezone;

  if (isAllSites) return null;

  return (
    <Paper
      withBorder
      radius="md"
      px="sm"
      py={6}
      style={{
        background: 'var(--mantine-color-body)',
        minWidth: 152,
      }}
    >
      <Group gap="xs" wrap="nowrap" align="center">
        <ThemeIcon variant="light" radius="xl" size={24} color="blue">
          <IconClock size={13} />
        </ThemeIcon>
        <Box>
          <Text size="10px" tt="uppercase" fw={700} c="dimmed" lts={0.8}>
            Local time
          </Text>
          <Group gap={4} align="baseline" wrap="nowrap">
            <Text
              fz="sm"
              fw={600}
              style={{ fontVariantNumeric: 'tabular-nums', lineHeight: 1.1 }}
            >
              {time}
            </Text>
            <Text size="10px" c="dimmed" fw={500}>
              {locationLabel}
            </Text>
          </Group>
        </Box>
      </Group>
    </Paper>
  );
};
